<script>
  export let isVisible;
</script>

<div class="background-component {isVisible ? 'visible' : ''}">
  <div class="fixed-background">
    <slot />
  </div>
</div>

<style>
  .background-component {
    position: fixed;
    top: 10%;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 1;
    visibility: none;
    justify-content: center;
    align-items: center;
    pointer-events: none;
    /* transition: opacity 0.2s linear;  */
    opacity: 0;
  }
  .background-component.visible {
    display: flex;
    opacity: 1;
  }
  .fixed-background {
    width: 100%;
    height: 100vh;
  }
</style>
